import { useEffect } from "react"
import { withRouter } from "react-router-dom"

interface ScrollToTopProps {
    location: string
}
const ScrollToTop = ({ location }: ScrollToTopProps) => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [location])

    return null
}

export default withRouter(ScrollToTop as any)
